<script>
</script>

<div class="content">
  <div class="image-container">
    <img
      src="404.jpg"
      alt="404 Image"
    />
  </div>

  <p>It seems like the page you are looking for doesn't exist.</p>

  <a href="/" class="back-home-link">Go back to the home page</a>
</div>

<style>
  .content {
    text-align: center;
    padding: 50px;
  }

  .error-message {
    font-size: 2rem;
    color: #e74c3c;
    margin-bottom: 20px;
  }

  .image-container {
    max-width: 500px;
    margin: 0 auto;
  }

  .image-container img {
    width: 60%;
    height: auto;
  }

  .back-home-link {
    display: block;
    margin-top: 20px;
    font-size: 1.2rem;
    color: #3498db;
    text-decoration: none;
  }

  .back-home-link:hover {
    text-decoration: underline;
  }
</style>
